export default "/images/vendor/flag-icons/flags/4x3/tn.svg?6c7055b6554b66542644bbac6b59b2ba";